'use client';
import useOchamaMig from '@/hooks/useOchamaMig';
export default function OchamaMigTrack(props: { trackType: string }) {
  useOchamaMig(props.trackType);
  return <></>;
}
